var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box-loader',{attrs:{"error":_vm.error,"loading":_vm.loading},on:{"retry":function($event){return _vm.retry()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }